import Slide from '@mui/material/Slide';
import React from 'react';

export const Transition = React.forwardRef((props, ref) => (
    <Slide direction="up" ref={ref} {...props} />
));
